import { TableFromFile } from '../../Tsv_parser';

export const StatisticsTable = () => {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  const suffix = version === 'v254' ? '_v254' : '';

  return (
    <>
      <h3 className="mt-5 text-lg font-semibold">Distribution of genes, diseases, and GDAs by source</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>Source</th>
              <th>Genes</th>
              <th>Diseases</th>
              <th>GDAs</th>
              <th>Evidences</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/gdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">Distribution of variants, diseases, and VDAs by source</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>Source</th>
              <th>Variants</th>
              <th>Diseases</th>
              <th>VDAs</th>
              <th>Evidences</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/vdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">DISGENET provides ample coverage of all disease areas...</h3>
      <img
        src="/static/images/plot_msh.svg"
        className="mx-2 my-5 ml-2 w-full h-auto"
        alt="DISGENET therapeutic areas"
      />

      <h3 className="mt-5 text-lg font-semibold">...and protein classes relevant for chemical R&D</h3>
      <img
        src="/static/images/plot_dto.svg"
        className="mx-2 my-5 ml-2 w-full h-auto"
        alt="DISGENET protein classes"
      />
    </>
  );
};
